import { Sprint } from 'api/sprint-planning/types';
import {
  PhaseAsParent,
  TaskAsParent,
} from 'components/organisms/templates/projects/commons/rearrange/types';
import type { Task } from 'data/tasks';
import { PhaseEntity, PhaseEntityType } from './generics';

export {
  converToEntityId,
  convertKeyToEntityId,
  extractId,
  extractParts,
} from 'data/projects/phase-entity';

export function isPhase(
  rearrangeEntity: PhaseAsParent | TaskAsParent,
): rearrangeEntity is PhaseAsParent {
  return typeof (rearrangeEntity as PhaseAsParent).projectPhase !== 'undefined';
}

export function isTask(entity: PhaseEntity): entity is Task {
  return typeof (entity as Task).taskId === 'number';
}

export function isSprint(entity: PhaseEntity): entity is Sprint {
  return typeof (entity as Sprint).sprintId === 'number';
}

export function isTaskId(fullyQualifiedId: string) {
  return fullyQualifiedId.startsWith(PhaseEntityType.Task);
}

export function getId(item: PhaseEntity, withEntityName: true): string;
export function getId(item: PhaseEntity, withEntityName?: false): number;
export function getId(item: PhaseEntity, withEntityName = false) {
  if (isTask(item)) {
    return withEntityName
      ? `${PhaseEntityType.Task}_${item.taskId}`
      : item.taskId;
  }
  if (isSprint(item)) {
    return withEntityName
      ? `${PhaseEntityType.Sprint}_${item.sprintId}`
      : item.sprintId;
  }

  return undefined;
}
